<template>
  <TabelaOSD
    :colunas="displayedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    :campos-modal="obterCamposModal"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getAdmin"
  >
    <template #toolbar-actions>
      <AssinaturasExport v-bind="pagination" :headers="headers" />
    </template>
    <template #toolbar-filters>
      <AssinaturasFilters :loading="table.isLoading" @filter="onFilter" />
    </template>
  </TabelaOSD>
</template>

<script>
import AssinaturasExport from './AssinaturasExport.vue';
import AssinaturasFilters from './AssinaturasFilters.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedAssinaturasData } from '../assinaturasService';
import { useToast } from 'vue-toastification';
import { toDate } from '@/modules/core/utils/formats';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';

const HIDDEN_FIELDS = ['identificadorEmpresa'];

export default {
  components: { AssinaturasExport, AssinaturasFilters, TabelaOSD },
  data: () => ({
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          label: computed((_) => i18n.global.t('identificadorDaEmpresa')),
          field: 'identificadorEmpresa',
        },
        {
          label: computed((_) => i18n.global.t('nomeDaEmpresa')),
          field: 'empresa',
        }, {
          label: computed((_) => i18n.global.t('tipoDaAssinatura')),
          field: 'tipoAssinatura',
        }, {
          label: computed((_) => i18n.global.t('dataHoraCompra')),
          field: 'dataHoraCompra',
          tdClass: 'text-break',
          formatFn: toDate,
        }, {
          label: computed((_) => i18n.global.t('dataHoraExpiracao')),
          field: 'expiraEm',
          tdClass: 'text-break',
          formatFn: toDate,
        }, {
          label: computed((_) => i18n.global.t('dataHoraExpiracaoGratuito')),
          field: 'finalPeriodoGratuito',
          tdClass: 'text-break',
          formatFn: toDate,
        }, {
          label: computed((_) => i18n.global.t('status')),
          field: 'status',
        },
        {
          label: computed((_) => i18n.global.t('plataformaRecebimento')),
          field: 'plataforma',
        },
      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
      ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
    `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'dataHoraCompra', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'dataHoraCompra',
      order: 'desc',
      search: '',
    },
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    displayedColumns() {
      return this.resolvedColumns.filter((column) => !HIDDEN_FIELDS.includes(column.field));
    },
    headers() { return this.resolvedColumns.map((column) => column.label); },
  },
  methods: {
    obterCamposModal(linha) {
      return [
        { titulo: this.$t('identificadorDaEmpresa'), valor: linha.identificadorEmpresa },
        { titulo: this.$t('uuid'), valor: linha.idEmpresa },
      ];
    },
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getAdmin();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getAdmin();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getAdmin();
    },
    async getAdmin() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedAssinaturasData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(ref(computed((_) => i18n.global.t('erroAoObterAsInfosDasAssinaturas'))));
      }
      this.table.isLoading = false;
    },
  },
};

</script>
